/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D button
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function SwitchButtons({
    width,
    height,
    textSize = "p1",
    textSizeDecimal,
    options,
    selected,
    selectedBackgroundColor = "#0066b3",
    unselectedBackgroundColor = "#262626",
    hoverColor = "#0786cf",
    textColor = "#f2f2f2",
    aframeClasses,
    ...otherAttributes
}) {
    const offset = height * 0.05;
    return (
        <a-entity class="SwitchButtons" {...otherAttributes}>
            <a-plane
                width={width / 2}
                height={height}
                color={selectedBackgroundColor}
                position={`${-width / 4} 0 0`}
            >
                <a-plane
                    class={aframeClasses}
                    width={width / 2 - offset}
                    height={height - offset}
                    color={
                        options[0].element === selected
                            ? selectedBackgroundColor
                            : unselectedBackgroundColor
                    }
                    animation__mouseenter={`property: color; startEvents: mouseenter; to: ${hoverColor}; dur:150`}
                    animation__mouseleave={`property: color; startEvents: mouseleave; to: ${
                        options[0].element === selected
                            ? selectedBackgroundColor
                            : unselectedBackgroundColor
                    }; dur:150`}
                    position={`0 0 ${height / 50}`}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        options[0].onClickHandler(e);
                    }}
                >
                    <Text
                        position="0 0 0"
                        align="center"
                        size={textSize}
                        sizeDecimal={textSizeDecimal}
                        width={width / 2 - offset}
                        text={options[0].element}
                        color={textColor}
                    />
                </a-plane>
            </a-plane>
            <a-plane
                width={width / 2}
                height={height}
                color={selectedBackgroundColor}
                position={`${width / 4} 0 0`}
            >
                <a-plane
                    class={aframeClasses}
                    width={width / 2 - offset}
                    height={height - offset}
                    color={
                        options[1].element === selected
                            ? selectedBackgroundColor
                            : unselectedBackgroundColor
                    }
                    animation__mouseenter={`property: color; startEvents: mouseenter; to: ${hoverColor}; dur:150`}
                    animation__mouseleave={`property: color; startEvents: mouseleave; to: ${
                        options[1].element === selected
                            ? selectedBackgroundColor
                            : unselectedBackgroundColor
                    }; dur:150`}
                    position={`0 0 ${height / 50}`}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        options[1].onClickHandler(e);
                    }}
                >
                    <Text
                        position="0 0 0"
                        align="center"
                        size={textSize}
                        sizeDecimal={textSizeDecimal}
                        width={width / 2 - offset}
                        text={options[1].element}
                        color={textColor}
                    />
                </a-plane>
            </a-plane>
        </a-entity>
    );
}

SwitchButtons.propTypes = {
    selected: PropTypes.string.isRequired,
    width: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    height: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default SwitchButtons;
